import { COLORS } from './colors';
import type { WeaponRarity } from './weapons';

/**
 * Weapon readability layer (docs/09 "Okunabilirlik"): ONE place that maps a
 * weapon to its look. The category tint is the shared palette table
 * (config/colors, docs/12 E4) — re-exported here so HUD, shop, glyphs and
 * crates read the same colours as projectiles and mounts.
 */
export { WEAPON_CATEGORY_COLOR } from './colors';

/**
 * Hull hardpoint of each weapon socket E1..E3 (ship-local, 128 px hull
 * canvas, nose = +X): E1 on the spine behind the cockpit, E2/E3 on the
 * wings. Every equipped weapon shows on the ship in its category colour.
 */
export const SOCKET_MOUNTS: ReadonlyArray<{ readonly x: number; readonly y: number }> = [
  { x: -18, y: 0 },
  { x: -14, y: -28 },
  { x: -14, y: 28 },
];

/** Pod size on the hull — big enough to read at gameplay zoom */
export const SOCKET_MOUNT_SCALE = 1.2;

/** Rarity rim / badge colour — same scale as the upgrade cards. */
export const WEAPON_RARITY_COLOR: Record<WeaponRarity, number> = {
  common: COLORS.rarityCommon,
  rare: COLORS.rarityRare,
  epic: COLORS.rarityEpic,
};

/** Per-weapon glyph icon (transparent, category tinted) — HUD chips, shop bays. */
export function weaponGlyphKey(weaponId: string): string {
  return `ui/weapon-${weaponId}`;
}

/** Per-weapon crate drop: glyph on the lid + rarity rim. */
export function weaponCrateKey(weaponId: string): string {
  return `pickup/crate-${weaponId}`;
}

/** i18n key of the rarity word shown on crates / notices / info panel. */
export function weaponRarityKey(rarity: WeaponRarity): string {
  return `wrarity.${rarity}`;
}
